import { render, staticRenderFns } from "./NewCompetencePopup.vue?vue&type=template&id=732314c2&"
import script from "./NewCompetencePopup.vue?vue&type=script&lang=js&"
export * from "./NewCompetencePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports